export default __webpack_public_path__ + "static/media/arcteryx-marked.747da32c.png";